// eslint-disable-next-line
export const urlRegex = new RegExp('^(http[s]?:\\/\\/([Ww]{3}\\.)?|ftp:\\/\\/([Ww]{3}\\.)?|[Ww]{3}\\.){1}([0-9A-Za-z-.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?');
